import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF4C51",
      stroke: "#FF4C51",
      "stroke-width": ".5",
      d: "M.58.597c.443-.47 1.2-.453 1.639-.005L8.5 6.873 14.78.592a1.16 1.16 0 0 1 1.636 0h-.001c.455.444.437 1.188.001 1.625l-6.282 6.282 6.282 6.292c.442.442.438 1.173.002 1.622-.444.457-1.2.44-1.638.003L8.5 10.134l-6.28 6.282c-.442.442-1.184.438-1.633.002-.457-.444-.44-1.19-.003-1.627l6.281-6.292L.584 2.217A1.164 1.164 0 0 1 .579.597Z"
    }, null, -1)
  ])))
}
export default { render: render }